import React from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'

class StateButton extends React.Component {
  state = {
    loading: false
  }

  componentWillReceiveProps(props) {
    if (!props.isRequesting) {
      this.setState({ loading: false })
    }
  }

  render() {
    const {
      onClick, id, color, children, disabled, block
    } = this.props

    return (
      <Button
        id={id}
        block={block}
        className={`btn-multiple-state ${this.state.loading
            && 'show-spinner'}`}
        color={color}
        onClick={() => {
          setTimeout(() => {
            if (this.props.isRequesting) this.setState({ loading: true })
          }, 50)
          if (this.props.formRef) this.props.formRef.handleSubmit()
          if (onClick) onClick()
        }}
        disabled={disabled || this.state.loading}
      >
        <span className="spinner d-inline-block">
          <span className="bounce1" />
          <span className="bounce2" />
          <span className="bounce3" />
        </span>
        <span className="icon success">
          <i className="simple-icon-check" />
        </span>
        <span className="icon fail">
          <i className="simple-icon-exclamation" />
        </span>
        <span className="label">{children}</span>
      </Button>
    )
  }
}

const mapStateToProps = ({ menu: { isRequesting } }) => ({ isRequesting })

export default connect(mapStateToProps)(StateButton)
